import React from 'react';
import { useSelector } from 'react-redux';
import { NextPage } from 'next';

import Layout from '~/src/features/_layout';
import Reviews from '~/src/features/reviews';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

const ReviewsPage: NextPage = () => {
    const { cityIn } = useSelector(getCurrentCity);
    const companyName = useSelector(selectCompanyName);

    return (
        <Layout
            title={`Отзывы о компании ${companyName} в ${cityIn} — история отзывов`}
            description={`О компании ${companyName} — просмотр отзывов о провайдере самого быстрого интернета и цифрового телевидения в ${cityIn}.`}
            withMenu={true}
            withFooter={true}
            withChat={true}
        >
            <Reviews />
        </Layout>
    );
};

ReviewsPage.getInitialProps = async(options) => {
    await initialProps(options);
    return {};
};

export default ReviewsPage;
